import { GetterTree } from 'vuex'
import * as types from './types'

export default <GetterTree<orgmap.state.OrgmapState, RootState>>{
    [types.ORG_ME](state) {
        return state.user
    },

    [types.ORG_SELECT_TREE_ITEM](state) {
        return state.selectTreeItem
    },


    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: C O M M O N S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //

    [types.ORG_OPTION_GET](state) {
        return state.options;
    },

    [types.ORG_MEMBER_LIST](state) {
        return state.members
    },

    //
    // ────────────────────────────────────────────────────────────────────── I ──────────
    //   :::::: W I T H   C O N T A I N E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────────────────
    //

    [types.ORG_CONTAINER_REGISTER](state) {
        return state.wish
    },

    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: M O B I L E : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //

    [types.ORG_USER_SELECT](state) {
        return state.selections.users
    },

    [types.ORG_CURRENT_TAB](state) {
        return state.currentTab;
    },

    [types.SEARCH_CHANGE](state) {
        return state.search;
    },

    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P A N Y : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //

    [types.ORG_COMPANY_CURRENT](state){
        return state.hr.currentCompany;
    },

    [types.ORG_COMPANY_LIST](state){
        return state.hr.companies;
    },

    [types.ORG_COMPANY_LOAD](state) {
        return state.hr.companies;
    },

    [types.ORG_COMPANY_LIST_WITHDISABLE](state){
        return state.hr.companies;
    },

    [types.ORG_COMPANY_LOAD_WITHDISABLE](state) {
        return state.hr.companies;
    },

    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: H R : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //

    [types.HR_TREE_LIST](state) {
        return state.hr.dept.items;
    },

    [types.HR_TREE_CURRENT](state) {
        return state.hr.dept.current;
    },

    [types.HR_TREE_PATH](state) {
        return state.hr.dept.path;
    },

    [types.HR_USERS_LIST](state) {
        return state.hr.user;
    },

    [types.HR_USERS_CURRENT](state) {
        return state.hr.user.current;
    },

    [types.HR_USER_SELALL](state) {
        return state.hr.user.selectAll;
    },
}
